import gameSettings from './constants/gameSettings';
import { getEquationOfLineFrom2Points } from './helpers/mathMethods';

export default class BackMVC {
    #lineEquationScaleFromGameDistanceCity;
    #lineEquationScaleFromGameDistanceMountains;
    #lineEquationScaleFromGameDistanceSky;
    #wrapper;
    #slowdownOverlay;
    #speedBoostOverlay;

    #cityScaleProperty = '--city-scale';
    #mountainsScaleProperty = '--mountains-scale';
    #skyScaleProperty = '--sky-scale';
    #regionProgressProperty = '--{regionName}-progress';

    // TODO мб обновлять фон только начиная с какой-то дистанции
    constructor(finalDistance) {
        this.setLineEquationScaleFromGameDistance(finalDistance);
        // this.#wrapper = document.getElementById('gameWrapper');
        this.#wrapper = document.querySelector('#game-back');
        this.#slowdownOverlay = document.querySelector('#game-collision-overlay');
        this.#speedBoostOverlay = document.querySelector('#game-speed-overlay');
        this.update(0.3);
        this.update100Vh();
    }

    displaySlowdownAura() {
        this.#slowdownOverlay.classList.add('active');
    }

    hideSlowdownAura() {
        this.#slowdownOverlay.classList.remove('active');
    }

    displaySpeedBoostAura() {
        this.#speedBoostOverlay.classList.add('active');
    }

    hideSpeedBoostAura() {
        this.#speedBoostOverlay.classList.remove('active');
    }

    setLineEquationScaleFromGameDistance(finalDistance) {
        this.#lineEquationScaleFromGameDistanceCity = getEquationOfLineFrom2Points([
            0,
            gameSettings.backgroundParams.scaleFrom
        ], [
            finalDistance,
            gameSettings.backgroundParams.scaleTo
        ]);

        this.#lineEquationScaleFromGameDistanceMountains = getEquationOfLineFrom2Points([
            0,
            gameSettings.backgroundParams.scaleFrom + 0.3
        ], [
            finalDistance,
            gameSettings.backgroundParams.scaleTo
        ]);

        this.#lineEquationScaleFromGameDistanceSky = getEquationOfLineFrom2Points([
            0,
            gameSettings.backgroundParams.scaleFrom + 0.3 + 0.2
        ], [
            finalDistance,
            gameSettings.backgroundParams.scaleTo
        ]);
    }

    update(gameDistance) {
        if (!this.#wrapper) return;

        const cityScale = this.#lineEquationScaleFromGameDistanceCity.k * gameDistance + this.#lineEquationScaleFromGameDistanceCity.b;
        const mountainsScale = this.#lineEquationScaleFromGameDistanceMountains.k * gameDistance
            + this.#lineEquationScaleFromGameDistanceMountains.b;
        const skyScale = this.#lineEquationScaleFromGameDistanceSky.k * gameDistance
            + this.#lineEquationScaleFromGameDistanceSky.b;

        this.#wrapper.style.setProperty(this.#cityScaleProperty, cityScale);
        this.#wrapper.style.setProperty(this.#mountainsScaleProperty, mountainsScale);
        this.#wrapper.style.setProperty(this.#skyScaleProperty, skyScale);
    }

    updateRegionProgress(activeRegion, activeRegionProgress = 0) {
        if (!activeRegion) return;
        const regionProgressVar = this.#regionProgressProperty.replace('{regionName}', activeRegion.name);

        this.#wrapper.style.setProperty(regionProgressVar, activeRegionProgress);
    }

    resetAllRegionsProgress(regions) {
        regions.forEach((region) => {
            this.updateRegionProgress(region, 0);
        });
    }

    update100Vh() {
        this.#wrapper.style.setProperty('--100vh', `${window.innerHeight}px`);
    }
}
